import React from 'react';
import { MapPin, Globe, Truck, X } from 'lucide-react';
import { Button } from '../ui/button';
import { useCurrency } from '../../context/CurrencyContext';

const LocationPermissionModal = () => {
    const { showLocationModal, handleAllowLocation, handleDenyLocation, setShowLocationModal } = useCurrency();

    if (!showLocationModal) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Backdrop */}
            <div 
                className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                onClick={() => handleDenyLocation()}
            />
            
            {/* Modal */}
            <div className="relative bg-background rounded-xl shadow-2xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-300">
                {/* Close button */}
                <button 
                    onClick={() => handleDenyLocation()}
                    className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
                    aria-label="Close"
                >
                    <X className="w-5 h-5" />
                </button>

                {/* Icon */}
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                    <MapPin className="w-8 h-8 text-primary" />
                </div>

                {/* Title */}
                <h2 className="text-xl font-semibold text-center mb-2">
                    Enhance Your Shopping Experience
                </h2>

                {/* Description */}
                <p className="text-muted-foreground text-center mb-6">
                    Allow location access to personalize your experience with local currency, nearby sellers, and accurate delivery estimates.
                </p>

                {/* Benefits */}
                <div className="space-y-3 mb-6">
                    <div className="flex items-center gap-3 text-sm">
                        <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                            <Globe className="w-4 h-4 text-green-600" />
                        </div>
                        <span>Show prices in your local currency</span>
                    </div>
                    <div className="flex items-center gap-3 text-sm">
                        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                            <MapPin className="w-4 h-4 text-blue-600" />
                        </div>
                        <span>Discover biscuit sellers near you</span>
                    </div>
                    <div className="flex items-center gap-3 text-sm">
                        <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                            <Truck className="w-4 h-4 text-orange-600" />
                        </div>
                        <span>Get accurate delivery time estimates</span>
                    </div>
                </div>

                {/* Buttons */}
                <div className="flex flex-col gap-3">
                    <Button 
                        onClick={handleAllowLocation}
                        className="w-full"
                        size="lg"
                        data-testid="allow-location-btn"
                    >
                        <MapPin className="w-4 h-4 mr-2" />
                        Allow Location
                    </Button>
                    <Button 
                        variant="ghost"
                        onClick={handleDenyLocation}
                        className="w-full text-muted-foreground"
                        data-testid="deny-location-btn"
                    >
                        Not Now
                    </Button>
                </div>

                {/* Privacy note */}
                <p className="text-xs text-muted-foreground text-center mt-4">
                    Your location is only used to improve your shopping experience. 
                    You can change your preferences anytime.
                </p>
            </div>
        </div>
    );
};

export default LocationPermissionModal;
